import MessageWithIcon from './MessageWithIcon';
export default MessageWithIcon;
